import React from 'react';
// Assurez-vous que l'import correspond bien au nom du fichier CSS
import './BookingForm.css';

function BookingForm() {
  // Gardez le même endpoint Formspree
  const formspreeEndpoint = "https://formspree.io/f/VOTRE_CODE_UNIQUE"; // !! METTEZ VOTRE CODE !!

  // Obtenir la date d'aujourd'hui pour le champ 'min' du date picker
  const today = new Date().toISOString().split('T')[0];

  return (
    // Conteneur principal du formulaire, stylé avec un fond blanc opaque en CSS
    <div className="booking-form-container">
      <h3 className="booking-title">Réservez Votre Table</h3>
      <p className="booking-subtitle">
        Envoyez-nous votre demande et nous vous confirmerons la disponibilité par téléphone ou email.
      </p>
      <form action={formspreeEndpoint} method="POST" className="booking-form">

        {/* Champ Nom */}
        <div className="form-group">
          <label htmlFor="booking-name">Nom :</label>
          <input type="text" id="booking-name" name="Nom" required />
        </div>

        {/* Champ Téléphone */}
        <div className="form-group">
          <label htmlFor="booking-phone">Téléphone :</label>
          <input type="tel" id="booking-phone" name="Téléphone" required placeholder="Ex: 0612345678"/>
        </div>

        {/* Champ Email */}
        <div className="form-group">
          <label htmlFor="booking-email">Email :</label>
          <input type="email" id="booking-email" name="Email" placeholder="facultatif"/>
        </div>

        {/* Ligne pour Date, Heure, Nombre de personnes */}
        <div className="form-row">
          <div className="form-group form-group-inline">
            <label htmlFor="booking-date">Date :</label>
            <input type="date" id="booking-date" name="Date" required min={today} />
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="booking-time">Heure :</label>
            <input type="time" id="booking-time" name="Heure" required />
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="booking-guests">Personnes :</label>
            <input type="number" id="booking-guests" name="Personnes" required min="1" placeholder="Nb."/>
          </div>
        </div>

        {/* Champ Message */}
        <div className="form-group">
          <label htmlFor="booking-message">Demande spéciale (facultatif) :</label>
          <textarea id="booking-message" name="Message" rows="4"></textarea>
        </div>

        {/* Bouton d'envoi */}
        <div className="form-group form-submit-group">
          <button type="submit" className="submit-button">Envoyer la Demande</button>
        </div>

        <p className="booking-confirmation-note">
           * Ceci est une demande de réservation. Votre table sera confirmée par la fromagerie.
        </p>
      </form>
    </div> // Fin de booking-form-container
  );
}

export default BookingForm;